import { render, staticRenderFns } from "./WeekItemDb.vue?vue&type=template&id=e28b9712"
import script from "./WeekItemDb.ts?vue&type=script&lang=ts&external"
export * from "./WeekItemDb.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports